var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2117 7.76172L11.459 8.47881",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9398 3.4983L8.41762 4.33176C8.01359 4.46477 7.57404 4.27362 7.3958 3.88739C7.2029 3.47343 7.37313 2.98107 7.78053 2.77467L10.2234 1.5463C10.6443 1.33405 11.1343 1.30562 11.5769 1.46776L15.1936 2.79067",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13477 7.76765H4.91295L7.46713 10.6302C7.73351 10.9389 8.16371 11.0494 8.54593 10.9075C8.92814 10.7655 9.18181 10.4008 9.18204 9.9931V9.54583L9.30931 9.59674C9.6803 9.74512 10.1007 9.69986 10.4316 9.47591C10.7625 9.25196 10.9608 8.87848 10.9609 8.47892H11.3166C11.7207 8.47864 12.09 8.25021 12.2708 7.88874C12.4515 7.52728 12.4127 7.09475 12.1704 6.77128L9.88749 3.84619",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1511 2.5872L7.89073 2.37265C7.62837 2.17945 7.3111 2.07523 6.98528 2.0752C6.79113 2.07512 6.59879 2.11241 6.41873 2.18501L3.18164 3.47956",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.24134H2.45455C2.83903 2.22532 3.16413 2.52311 3.18182 2.90752V7.57443C3.16413 7.95895 2.83915 8.25695 2.45455 8.24134H1",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3635 8.24134H15.9089C15.5243 8.25695 15.1993 7.95895 15.1816 7.57443V2.90752C15.1993 2.52311 15.5244 2.22532 15.9089 2.24134H17.3635",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18198 9.54575L8.4707 8.83447",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9602 8.47877L9.89258 7.41113",
    stroke: "#0D54BD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingClicked);
export default __webpack_public_path__ + "static/media/Meeting_clicked.154540942b6109ef88ff28571f7ab613.svg";
export { ForwardRef as ReactComponent };